import ServiceFetch from '../../../../utilities/ServiceFetch.js';
/**
 * This class handles adding items to the China cart.
 */
export default class ChinaCartService {
    /**
     * Constructor.
     *
     * @param options Options.
     * @param options.endpoint Endpoint.
     */
    constructor(options) {
        this.endpoint = options.endpoint;
    }
    /**
     * Adds items to shopping cart in IRW.
     *
     * @param options Options.
     * @param options.items Array of shopping items.
     * @param options.token Token.
     * @param options.designCode VPC/design code to group articles in checkout.
     * @returns Promise object.
     */
    async addToCart(options) {
        await ServiceFetch.json(`${this.endpoint}/add-planner-design-to-cart`, {
            method: 'post',
            credentials: 'same-origin',
            headers: this.getHeaders(options.token),
            body: this.getAddToCartBody(options.items, options.designCode)
        });
        const cartCount = await this.getCartCount(options);
        return {
            cartCount,
            errorList: []
        };
    }
    /**
     * Returns cart count for a shopping cart.
     *
     * @param options Options.
     * @param options.token Token.
     * @returns Promise object.
     */
    async getCartCount(options) {
        const response = await ServiceFetch.json(this.endpoint, {
            method: 'get',
            credentials: 'same-origin',
            headers: this.getHeaders(options.token)
        });
        let quantity = 0;
        for (const item of response.items) {
            quantity += item.quantity;
        }
        return quantity;
    }
    /**
     * Returns the body.
     *
     * @param items Items.
     * @param designCode VPC Code to group articles with.
     * @returns Add to cart body.
     */
    getAddToCartBody(items, designCode) {
        return JSON.stringify({
            products: items.map((item) => ({
                productFullId: (item.type.toUpperCase() === 'SPR' ? 's' : '') + item.id,
                quantity: item.quantity
            })),
            designCode
        });
    }
    /**
     * Returns headers.
     *
     * @param token Token.
     * @returns Headers.
     */
    getHeaders(token) {
        return {
            'content-type': 'application/json',
            'x-client-channel': 'WEB',
            'x-client-platform': 'PcWeb',
            authorization: `Bearer ${token}`
        };
    }
}
//# sourceMappingURL=ChinaCartService.js.map